import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import moment from "moment";

export const getCourseEnrollableTurmas = async (courseId) => {
  const res = await axios.middleware(
    "https://middleware.cadernovirtual.com.br/aluno.asmx/AutoinscricaoTurmas",
    {
      params: {
        alunoid: _cookies.getItem("auth").user?.alunoid,
        disciplinaid: courseId,
        data_hora_local: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
      },
    }
  );
  return res[0].data;
};

export const useCourseEnrollableTurmas = ({ config, courseId } = {}) => {
  return useQuery({
    ...config,
    queryFn: () => getCourseEnrollableTurmas(courseId),
    queryKey: ["enrollableClasses", courseId],
  });
};
